import { useQuery } from '@apollo/client';
import { GET_CANDIDATE_SEARCH_TOTALS_QUERY } from '../queries/candidateQueries';

export const useCandidateSearchTotals = (companyId) => {
  const { loading, error, data, refetch } = useQuery(GET_CANDIDATE_SEARCH_TOTALS_QUERY, {
    variables: { 
      companyId
    },
    fetchPolicy: 'cache-first',
    skip: !companyId
  });

  const totalCandidates = data?.getCandidateSearchTotals?.totalCandidates || 0;
  const totalReferrals = data?.getCandidateSearchTotals?.totalReferrals || 0;
  const totalApplications = data?.getCandidateSearchTotals?.totalApplications || 0;

  return {
    loading,
    error,
    totalCandidates,
    totalReferrals,
    totalApplications,
    refetch
  };
};